module.exports = __webpack_public_path__ + "media/images/Favori_blanc-6dd25b96d8d4efa246e104c12a057067.svg";